import { SupplierUpdateForm } from 'components/Pages/Suppliers';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const SupplierUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/fornecedores');
  }, [navigate]);

  return (
    <Scaffold>
      <SupplierUpdateForm supplierId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
